<div class="news-wks-component" (window:beforeunload)="ngOnDestroy()">
  <div class="component-header">
    <span>{{ title }}</span>
    <div class="icons gridster-ignore-drag">
      <mat-icon disableWksChange svgIcon="close" (click)="removeItemFromWorkspace()" matTooltipPosition="above"
        [matTooltip]="removeFromWksTooltip">
      </mat-icon>
    </div>
  </div>
  <div class="news-content gridster-ignore-drag">
    <div class="component-filter row">
      <div class="col-6 agency">
        <mat-form-field>
          <mat-select placeholder="Escolha um canal" [(ngModel)]="filterObj.agencyID"
            (selectionChange)="searchNews(); resetInterval();">
            <mat-option *ngFor="let item of agencyList" value="{{item.value}}">{{item.desc}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6 search">
        <mat-form-field>
          <input matInput placeholder="Pesquisar Notícia" [formControl]="searchStrCtrl">
          <mat-icon matSuffix class="icon-search-input" svgIcon="search"></mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div class="component-container">
      <app-spinner-loading *ngIf="loading; else NewsList"></app-spinner-loading>
      <ng-template #NewsList>
        <div *ngFor="let news of newsList" class="news-list-card">
          <div class="news-date">
            {{ news.agencyDescription }} -
            {{ news.newsDate | date: 'dd ' }} de {{ news.newsDate | date: ' MMM ' }} de
            {{ news.newsDate | date: ' yyyy HH:mm:ss' }}
          </div>
          <div class="news-title" (click)="openNews(news)">{{news.title}}</div>
          <hr>
        </div>
        <div class="more-news">
          <span (click)="openNews()">Ver todas as notícias</span>
        </div>
      </ng-template>
    </div>
  </div>
</div>
